import type { Option } from "@caprikorn/dynamo-ui/lib/components/dataEntry/Select/Select.types";
import { useContext } from "react";

import { GroupReferenceContext } from "@contexts/GroupReferences/GroupReferences.context";
import { useGetGroups } from "@services/apiEcms/useGetGroups";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

export const useGroupsDropdown = (onGroupChange: Array<() => void> = []) => {
  const { t } = useCustomTranslation("main");
  const { data } = useGetGroups();
  const { currentGroup, changeCurrentGroup } = useContext(
    GroupReferenceContext,
  );

  const formattedGroups: Option[] =
    data?.map(({ name, reference }) => ({ label: name, value: reference })) ??
    [];

  return {
    groupsDropdownOptions: formattedGroups,
    groupsOnDropdownChange: (select: Option | null) => {
      onGroupChange?.forEach((fn) => fn());
      changeCurrentGroup(select?.value ?? t("noSelectedGroup"));
    },
    groupsDropdownValue: {
      label:
        formattedGroups.find((group) => group.value === currentGroup)?.label ??
        t("noSelectedGroup"),
      value: currentGroup,
    },
  };
};
